import { appSelectors } from '@appStore/reducers/app'
import { connectorApi } from 'api/connector/api'
import { useNavigate } from 'react-router-dom'
import { notifyError } from 'shared/errors'
import { useAppSelector } from 'shared/hooks'
import { LoadingButton, StackIcon } from 'shared/ui'

import css from './SignIn.module.scss'
export function SignInMember({ id = '' }: { id?: string }) {
	const personaId = useAppSelector(
		state => appSelectors.persona(state)?.personaId
	)
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)
	const [changePerson, { isLoading }] =
		connectorApi.useSignInUnderTeamMemberMutation()
	const navigate = useNavigate()

	const isRestricted = personaId === id || isImpersonated

	if (isRestricted) {
		return null
	}

	const signIn = () =>
		changePerson(id)
			.unwrap()
			.then(() => navigate('/campaigns'))
			.catch(notifyError)

	return (
		<LoadingButton
			className={css.action}
			isLoading={isLoading}
			onClick={signIn}
			type='button'
		>
			<StackIcon icon='sign-in' key='➡️' width={14} /> Sign in
		</LoadingButton>
	)
}
